export default "__VITE_ASSET__rMNc8hq8__"